<template>
  <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-header style="padding:2rem 1rem 0rem 1rem;">
      <div>已选物资：{{form.piece}}</div>
    </zj-layout-header>
    <zj-layout-main style="padding:1rem 1rem;">
      <zj-layout-container>
        <zj-layout-main style="padding:0px 0px;">
          <el-table :data="gridData" height="100%" max-height="27rem" style="min-height:27rem;">
            <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
            <el-table-column property="name" label="物资名称"></el-table-column>
            <el-table-column
              property="materialType"
              label="物资类型"
              :formatter="materialType"
              align="center"
            >
              <template slot-scope="scope">
                <span v-for="item in options" :key="item.id">
                  <span v-if="item.code == scope.row.materialType">{{ item.value }}</span>
                </span>
              </template>
            </el-table-column>
            <el-table-column property="stock" label="现库存" align="center"></el-table-column>
          </el-table>
        </zj-layout-main>
        <zj-layout-footer style="padding:1rem 0px;">
          <el-divider></el-divider>
          <el-form :model="form" ref="form" class="zj-search-form" label-width="8rem" style="margin-top:4rem;" :rules="rules">
            <el-form-item label="出库数量" style="display:inline-block;">
              <el-input-number
                style="width:50rem;"
                v-model="form.operationNum"
                autocomplete="off"
                :min="1"
                :max="MaxStockNum"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="领取人" style="display:inline-block;" prop="person">
              <el-input style="width:50rem;" v-model="form.person"></el-input>
            </el-form-item>
            <el-form-item label="领取日期" style="display:inline-block;">
              <el-date-picker
                type="datetime"
                placeholder="选择日期"
                v-model="form.OutDate"
                style="width:50rem;"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="pickerOptions"
                :clearable="false"
              ></el-date-picker>
            </el-form-item>
          </el-form>
        </zj-layout-footer>
      </zj-layout-container>
    </zj-layout-main>
    <zj-layout-footer style="text-align:center;">
      <el-button @click="onBack()">取消</el-button>
      <el-button @click="submitForm()">确定</el-button>
    </zj-layout-footer>
  </zj-layout-container>
</template>

<script>
import { getDictionary } from '@/api/src/emergency_common'
import { materialInoutBatchSave } from '@/api/src/emergency_materialInout'
export default {
  data() {
    return {
      loading: true,
      loadingText: '加载中',
      gridData: [],
      form: {
        piece: "（共0条）",
        operationNum: 1,
        OutDate: "",
        person:""
      },
      MaterialTypeDic: [],
      MaxStockNum: 1,
      rules: {
        person: [
          { required: true, message: "请输入领取人", trigger: "blur" }
        ]
      },
      options: [],
      pickerOptions: { // 限制收货时间不让选择今天以前的
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
        }
      }
    }
  },
  props: {
    viewData2: Object,
    materialTypedate2: Object
  },
  created: function() {
    this.form.OutDate = this.getDayTimer()
    this.basedatabind();
    var selectData = this.viewData2;
    this.form.piece = "（共" + selectData.length + "条）";
    this.gridData = selectData;
    this.form.person = this.user.DisplayName;
    this.MaxStockNum = selectData[0].StockNum;
    for (var i = 0; i < selectData.length; i++) {
      var item = selectData[i];
      if (this.MaxStockNum > item.StockNum) {
        this.MaxStockNum = item.StockNum;
      }
    }
    if (this.MaxStockNum == 0) {
      this.form.operationNum = 0;
    }
  },
  methods: {
    //取消按钮
    onBack() {
      this.$emit("cancel", {});
    },
     submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.save();
        } else {
          console.error("error submit!!");
          return false;
        }
      });
    },
    //确定按钮
    save() {
      const datalist = []
      this.viewData2.forEach(item => {
        datalist.push({
          belongEnterprise: item.belongEnterprise,
          createdate: item.createdate,
          materialId: item.id,
          modifydate: item.modifydate,
          warehouseId: item.warehouseId
        })
      })
      datalist.forEach(item => {
        item.type = 1 // 出库
        item.operationNum = parseInt(this.form.operationNum);
        item.operationPerson = this.user.DisplayName
        item.receiver = this.form.person
        item.operationDate = this.form.OutDate
      });
      this.loading = true;
      this.loadingText = '保存中...';
      materialInoutBatchSave(datalist)
        .then(r => {
          if (r) {
            this.$message({
              type: "success",
              message: "出库成功!"
            });
          } else {
            this.$message({
              type: "error",
              message: "出库失败!"
            });
          }
          this.logInfo.ActionName = "应急物资出库";
          this.logInfo.LogMessage = r ? "应急物资出库成功" : "应急物资出库失败";
          this.logInfo.ModuleName = "应急系统";
          this.logInfo.PageName = "应急物资管理";
          this.addOperationLog();
          this.$emit("search", {});
          this.$emit("ok", {});
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.loading = false;
        });

    },
    //基础数据绑定
    basedatabind() {
      this.loading = true;
      this.loadingText = '加载中...';
      getDictionary('emergency_material_type')
        .then(res => {
          //物资类型
          this.options = res.data.records;
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.loading = false;
        });
    },
    getDayTimer () {
      var date = new Date()
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? ('0' + m) : m
      var d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      var currentdate = y + '-' + m + '-' + d;
      var hh = date.getHours()
      hh = hh < 10 ? ('0' + hh) : hh
      var mm = date.getMinutes()
      mm = mm < 10 ? ('0' + mm) : mm
      var ss = date.getSeconds()
      ss = ss < 10 ? ('0' + ss) : ss
      var time = hh + ':' + mm + ':' + ss;
      return currentdate + " " + time
    }
  }
};
</script>
<style lang="scss" scoped>
.zj-layout-container .zj-layout-main .zj-table-container {
  margin-top: 0.8rem;
  margin-bottom: 1rem;
  flex: 1 1 auto;
  overflow: auto;
  overflow-x:hidden;
  max-height: 30rem;
}
</style>